import { lazy } from 'react'

export const CheckInboxV2 = lazy(() => import('./CheckInboxV2'))
